import { render, staticRenderFns } from "./Cactivity.vue?vue&type=template&id=487f7852&"
import script from "./Cactivity.vue?vue&type=script&lang=js&"
export * from "./Cactivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports